import { isNil } from 'lodash';
import { ErrorInfo, PureComponent, ReactNode } from 'react';
import { MBAnalytics } from '@shared/util/analytics';
import { MBSentry } from '@shared/util/sentry';
import { UnchartedWaters } from './UnchartedWaters';

interface ErrorProps {
  children: ReactNode;
}

interface ErrorState {
  error?: Error;
  errorInfo?: ErrorInfo;
}

export class ErrorBoundary extends PureComponent<ErrorProps, ErrorState> {
  state: ErrorState = {};

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error);
    console.log(errorInfo);
    try {
      MBSentry.exception({ error, data: { caughtBy: 'MBUnhandledError', errorInfo } });
      MBAnalytics.track('UnhandledException::UnchartedWatersPrompt', { error, errorInfo });
    } catch (e) {
      console.log(e);
    }
    this.setState({ error, errorInfo });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (isNil(error)) {
      return children;
    }

    return <UnchartedWaters error={error} />;
  }
}
